<template>
    <div class="top-tag-list">

        <span class="left-side" v-if="user.workerIsNovice === true">
            <span
                    v-on:click="onTagClick('job-for-free')"
                    class="tag tag-default"
                    style="color: black;">
                {{'free mission'|trans}}
            </span>

        </span>

        <span class="left-side" v-else>
            <span
                    v-if="job.isWorkerTheOwner === true"
                    class="tag tag-info ">
                 {{'Own customer'|trans}}
            </span>
            <span
                    v-if="job.interventionType === 'continuation'"
                    v-on:click="onTagClick('continuation')"
                    class="tag tag-default"
                    style="color: black;">
                cont.
            </span>


            <span v-if="job.isWorkerTheOwner !== true">
                <span
                        v-if="job.isPureContact === true && job.disclosed === true"
                        v-on:click="onTagClick('non-refundable')"
                        class="tag tag-info ">
                     {{'Non refundable'|trans}}
                </span>
                <span
                        v-if="job.isPureContact === true"
                        v-on:click="onTagClick('pure-contact-icon')"
                        class="tag tag-default"
                        style="background: #a139ff;">
                    <img v-bind:src="$absoluteAssetPath('handshake-white.svg')" style="width: 20px;"/>
                </span>
                <span
                        v-if="job.isPureContact === true"
                        v-on:click="onTagClick('pure-contact')"
                        class="tag tag-default"
                        style="color: white; background: #a139ff;">
                    pure contact
                    {{ jobAccountPurchaseAmountAsNumber.toFixed(0) }}{{ $currency.symbol(user.country)}}
                </span>
                <span
                        v-else
                        v-on:click="onTagClick('sub-contractor')"
                        class="tag tag-default"
                        style="color: black;">
                    sub-contractor
                    <template v-if="job.selectedSlotScore !== null">
                        {{ job.selectedSlotScore.toFixed(0) }}p.
                    </template>
                </span>
                <span
                        v-if="job.first === true"
                        v-on:click="onTagClick('first')"
                        class="tag tag-default"
                        style="color: black;">
                    1st
                </span>
                <span
                        v-if="job.interventionType === null || job.interventionType === 'new'"
                        v-on:click="onTagClick('new')"
                        class="tag tag-default"
                        style="color: black; background: #92f783;">
                    new
                </span>
                <span
                        v-if="job.interventionType === 'continuation'"
                        v-on:click="onTagClick('continuation')"
                        class="tag tag-default"
                        style="color: black;">
                    cont.
                </span>
                <span
                        v-if="job.interventionType === 'warranty'"
                        v-on:click="onTagClick('warranty')"
                        class="tag tag-default"
                        style="color: black;">
                    warr.
                </span>
                <!-- <span
                        v-if="jobIsNormalCost"
                        v-on:click="onTagClick('normal-cost')"
                        class="tag tag-default"
                        style="color: black;">
                    normal-cost
                </span> -->
                <span
                        v-if="job.supplement !== null && job.supplement !== 0"
                        v-on:click="onTagClick('supplement')"
                        class="tag tag-default"
                        style="color: black;">
                    supplement {{ job.supplement }}{{ $currency.symbol(user.country)}}
                </span>
            </span>
        </span>
        <TransitionExpand>
            <div
                    v-if="tagExplained !== null"
                    class="tag-explanation">
                <div>
                    <i
                            v-on:click="closeTagExplanation"
                            class="fa fa-close fa-2x close-button float-right"></i>
                    {{ tagExplanationText }}
                </div>
            </div>
        </TransitionExpand>
    </div>
</template>

<script>
    import TransitionExpand from '../TransitionExpand';

    export default {
        components: {TransitionExpand},
        props: {
            job: Object,
            user: Object,
        },
        data() {
            return {
                tagExplained: null,
            };
        },
        methods: {
            onTagClick(tagName) {
                if (this.tagExplained === tagName) {
                    this.tagExplained = null;
                }
                else {
                    this.tagExplained = tagName;
                }
            },
            closeTagExplanation() {
                this.tagExplained = null;
            },
        },
        computed: {
            jobAccountPurchaseAmountAsNumber() {
                if (this.job.account.purchaseAmount === null) {
                    return 0;
                }
                return Number.parseFloat(this.job.account.purchaseAmount);
            },
            jobIsNormalCost() {
                if (this.job.pricePolicy.hopeMultiplier === null) {
                    return true;
                }
                return Number.parseFloat(this.job.pricePolicy.hopeMultiplier) > 1.3;
            },
            tagExplanationText() {
                if (this.tagExplained === null) {
                    return null;
                }

                // compute tag explanation label
                let tagExplanationLabel = this.tagExplained;
                tagExplanationLabel = tagExplanationLabel.replace('pure-contact-icon', 'pure-contact');
                if (this.job.isPureContact === true && ['normal-cost', 'low-cost'].includes(tagExplanationLabel)) {
                    tagExplanationLabel = tagExplanationLabel + '_pure-contact';
                }
                tagExplanationLabel = 'tag-explanation_' + tagExplanationLabel;

                // compute translation parameters
                const translationParameters = {
                    supplement: this.job.supplement,
                    purchaseAmount: this.jobAccountPurchaseAmountAsNumber.toFixed(2),
                };
                if (this.job.isPureContact === true && this.user.pricePolicies !== undefined) {
                    translationParameters.lowCostEquivalentPurchaseAmount = (this.jobAccountPurchaseAmountAsNumber / (this.user.pricePolicies.maxHopeMultiplier / this.user.pricePolicies.minHopeMultiplier)).toFixed(2);
                    translationParameters.lowCostToNormalCostPercentage = ((this.user.pricePolicies.maxHopeMultiplier / this.user.pricePolicies.minHopeMultiplier - 1) * 100).toFixed(0);
                }
				translationParameters.currency = this.$currency.symbol(this.user.country);
                return this.$options.filters
                    .trans(tagExplanationLabel, translationParameters)
                    .replace(/_percents_/g, '%')
                ;
            },
        },
    }
</script>

<style scoped lang="scss">
    .top-tag-list {
        display: inline-block;
        margin-bottom: 5px;
        .left-side .tag {
            margin-right: 5px;
            margin-bottom: 5px;
        }
    }
    .tag-explanation {
        background: #efefef;
        border-radius: 4px;
        text-transform: none;
        div {
            padding: 8px;
            .close-button {
                font-size: 18px;
                color: #6b6b6b;
                margin-top: -2px;
            }
        }
    }
</style>
